import React, { useEffect, useState } from "react";
import style from "./style.module.scss";
import Modal from "../../../../../components/modal";
import MerchantDetails from "../../MerchantDetails/MerchantDetails";
import FileIcon from "../../../../../assets/svg/icons/common/file";
import ButtonIcon from "../../../../../components/ButtonIcon/ButtonIcon";
import toast from "react-hot-toast";
import { SendService } from "../../../../../../api";
import moment from "moment";
import useApplicationStore from "../../../../../stores/application";

function Submit({ isOpen, onClose, appData, files, processor }) {
  const activeApp = useApplicationStore((state) => state.activeApp);
  const [selectedFiles, setSelectedFiles] = useState({});
  const [selectedUploadedFiles, setSelectedUploadedFiles] = useState([]);
  
  useEffect(() => {
    const filesObject = files.reduce((acc, file) => {
      acc[file] = true;
      return acc;
    }, {});

    setSelectedFiles(filesObject);
  }, [files]);

  const handleCheckboxChange = (option) => {
    let updated_files = { ...selectedFiles, [option]: !selectedFiles[option] };
    setSelectedFiles(updated_files);
  };

  const submitToProcessor = () => {
    let data = {
      id: activeApp.id,
      service: processor.value,
      selectedFiles: selectedFiles,
      selectedUploadedFiles: selectedUploadedFiles,
      v2_enabled: true,
    };

    const toastId = toast.loading("submitting to bank", {
      duration: 30 * 1000,
    });
    SendService(data)
      .then((res) => {
        if (res.status) {
          toast.success("Submitted to bank successfully", {
            duration: 10 * 1000,
            id: toastId,
          });
        } else {
          toast.error(res.message, { duration: 10 * 1000, id: toastId });
        }
      })
      .catch((err) => {
        const errorMessage = err?.data?.message || err.statusText;
        toast.error(errorMessage, { duration: 10 * 1000, id: toastId });
        onClose();
      })
      .finally(() => {
        onClose();
      });
  };

  useEffect(() => {
    if(appData?.uploads){
      setSelectedUploadedFiles(appData?.uploads?.map(upload => upload.id));
    }
  }, [appData]);

  return (
    <Modal
      header={"Please read the details before proceed"}
      isOpen={isOpen}
      onClose={onClose}
      size={'md'}
      customClass={style.modalParent}
    >
      <div className={style.modal_content}>
        <h5 className={style.heading}>Merchant Info</h5>

        <MerchantDetails appData={appData} />

        <h5 className={style.heading} style={{ marginTop: "24px" }}>
          Select/Unselect Files to be submitted
        </h5>
        <div className={`${style.submission_data_list}`}>
          {files.map((file, index) => (
            <label key={index} className={style.list_item}>
              <input
                type="checkbox"
                name=""
                id=""
                checked={selectedFiles[file]}
                onChange={() => handleCheckboxChange(file)}
              />
              <FileIcon />
              <span>{file}</span>
            </label>
          ))}
        </div>

        <div className={`${style.submission_data_list}`}>
          <h5 className={style.heading} style={{ marginTop: "24px" }}>
            Select/Unselect user uploaded files
          </h5>
          { appData?.uploads && appData?.uploads?.length > 0 && appData?.uploads?.map((file, index) => (
            <label key={index} className={style.list_item}>
              <input
                type="checkbox"
                name=""
                id=""
                checked={selectedUploadedFiles?.includes(file.id)}
                onChange={() => {
                  if(selectedUploadedFiles?.includes(file.id)){
                    setSelectedUploadedFiles(selectedUploadedFiles.filter(id => id !== file.id));
                  }else{
                    setSelectedUploadedFiles([...selectedUploadedFiles, file.id]);
                  }
                }}
              />
              <FileIcon />
              <span>{file.file} - {file.title} - {moment(file.created_at).format("DD MMM, YY | HH:mm")}</span>
            </label>
          ))}
        </div>

        <footer className={style.footer}>
          <ButtonIcon textColor="#4C70EF" onClick={onClose}>
            Cancel
          </ButtonIcon>
          <ButtonIcon
            bgColor={"#4C70EF"}
            textColor="#FFF"
            onClick={() => submitToProcessor()}
          >
            {" "}
            Confirm
          </ButtonIcon>
        </footer>
      </div>
    </Modal>
  );
}

export default Submit;
